import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { App } from './app/App';
import './app/styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function routerBasename(): string | undefined {
  const raw = (import.meta.env.BASE_URL || '/').trim();
  if (!raw || raw === '/') return undefined;
  const normalized = raw.endsWith('/') ? raw.slice(0, -1) : raw;
  return normalized || undefined;
}

function routerMode(): 'browser' | 'hash' {
  const raw = String(import.meta.env.VITE_ROUTER_MODE || 'hash').trim().toLowerCase();
  return raw === 'browser' ? 'browser' : 'hash';
}

const Router = routerMode() === 'browser' ? BrowserRouter : HashRouter;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router basename={routerBasename()}>
        <App />
      </Router>
    </QueryClientProvider>
  </React.StrictMode>,
);
